export const DashboardStyles= 
{
   iconColor: { color: "white" },
   headingColor: { color: "#00BBBB" },
};